/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ask_AnythingInputs */

const en_ask_anything = /** @type {(inputs: Ask_AnythingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask anything...`)
};

const es_ask_anything = /** @type {(inputs: Ask_AnythingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pregunta cualquier cosa...`)
};

const fr_ask_anything = /** @type {(inputs: Ask_AnythingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demandez n'importe quoi...`)
};

const de_ask_anything = /** @type {(inputs: Ask_AnythingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frag alles...`)
};

const ja_ask_anything = /** @type {(inputs: Ask_AnythingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`何でも聞いてください...`)
};

const zh_ask_anything = /** @type {(inputs: Ask_AnythingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提出任何问题...`)
};

const ar_ask_anything = /** @type {(inputs: Ask_AnythingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسأل عن أي شيء...`)
};

const id_ask_anything = /** @type {(inputs: Ask_AnythingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanyakan apa saja...`)
};

const it_ask_anything = /** @type {(inputs: Ask_AnythingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiedi qualsiasi cosa...`)
};

const ru_ask_anything = /** @type {(inputs: Ask_AnythingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спросите о чем угодно...`)
};

const pt_ask_anything = /** @type {(inputs: Ask_AnythingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pergunte qualquer coisa...`)
};

const ko_ask_anything = /** @type {(inputs: Ask_AnythingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무엇이든 물어보세요...`)
};

/**
* | output |
* | --- |
* | "Ask anything..." |
*
* @param {Ask_AnythingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ask_anything = /** @type {((inputs?: Ask_AnythingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ask_AnythingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ask_anything(inputs)
	if (locale === "es") return es_ask_anything(inputs)
	if (locale === "fr") return fr_ask_anything(inputs)
	if (locale === "de") return de_ask_anything(inputs)
	if (locale === "ja") return ja_ask_anything(inputs)
	if (locale === "zh") return zh_ask_anything(inputs)
	if (locale === "ar") return ar_ask_anything(inputs)
	if (locale === "id") return id_ask_anything(inputs)
	if (locale === "it") return it_ask_anything(inputs)
	if (locale === "ru") return ru_ask_anything(inputs)
	if (locale === "pt") return pt_ask_anything(inputs)
	return ko_ask_anything(inputs)
});